export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بحث"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انقر لتحديد الأعمدة التي سيتم عرضها"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الأعمدة المعروضة"])}
}